/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DoctorsPage } from '../models/DoctorsPage';
import type { Store } from '../models/Store';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StoreService {
    /**
     * @param userId
     * @returns Store
     * @throws ApiError
     */
    public static storeControllerEmployeeStores(
        userId: string,
    ): CancelablePromise<Array<Store>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/store/employee/{userID}',
            path: {
                'userID': userId,
            },
        });
    }
    /**
     * Get available doctors.
     * Get available doctors.
     * @param storeId
     * @param companyId
     * @param offset
     * @param limit
     * @returns DoctorsPage The requested doctors
     * @throws ApiError
     */
    public static storeControllerGetDoctors(
        storeId: string,
        companyId: string,
        offset?: number,
        limit?: number,
    ): CancelablePromise<DoctorsPage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/store/doctors/{storeID}/{companyID}',
            path: {
                'storeID': storeId,
                'companyID': companyId,
            },
            query: {
                'offset': offset,
                'limit': limit,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `NotFound`,
                422: `Some of provided data are invalid due to defined schema.`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Get an existing store.
     * Get an existing store by ID.
     * @param storeId
     * @returns Store The requested store.
     * @throws ApiError
     */
    public static storeControllerStore(
        storeId: string,
    ): CancelablePromise<Store> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/store/{storeID}',
            path: {
                'storeID': storeId,
            },
            errors: {
                404: `NotFound`,
            },
        });
    }
}
